module.exports = __webpack_public_path__ + "media/img/marquee/marquee-training-tactics-f549a46d600acfa8c00f36c2c60b98e7.jpg";